<template>
  <div class="buy-now">
    <div
      class="text-center position-relative"
      :class="{ '--loading': isLoading }"
    >
      <div class="button button--buy col-12" @click="openBuyNowModal">
        Купить
      </div>
      <Preloader v-if="isLoading" class="for-button" invert />
    </div>

    <modal-window :show="showBuyNowModal" @close="showBuyNowModal = false">
      <template v-slot:popup-title
        >Купить лот №: {{ item.contractNumber }} <br />
        {{ item.car.name }}
      </template>
      <template v-slot:popup-content>
        <div class="buy-now-text">
          Нажатием кнопки &laquo;Купить&raquo; вы&nbsp;подтверждаете намерение
          приобрести автомобиль.
          <br />
          <br />
          Продавец вправе принять или отклонить заявку. Срок
          рассмотрения&nbsp;&mdash; до 48&nbsp;часов.
          <br />
          <br />
          Отказ от&nbsp;покупки после нажатия кнопки &laquo;Купить&raquo;
          считается нарушением правил платформы и&nbsp;может повлечь ограничение
          доступа к&nbsp;торгам.
        </div>
        <div class="price">
          <div>Стоимость:</div>
          <b> {{ formatNumber(item.betData.current) }} &#x20bd; </b>
        </div>

        <div
          v-if="!byNowError"
          class="text-center position-relative mt-3"
          :class="{ '--loading': isBuying }"
        >
          <button class="button button--buy col-12" @click="buyNowHandler">
            Купить
          </button>
          <Preloader v-if="isBuying" class="for-button" invert />
        </div>

        <div v-else class="text-center mt-3">
          <button class="button button--dark col-12" @click="updateList">
            {{ page === "item" ? "Обновить информацию" : "Обновить список" }}
          </button>
          <div class="buyNowError">
            {{ byNowError }}
          </div>
        </div>
      </template>
    </modal-window>

    <modal-window :show="showErrorModal" @close="showErrorModal = false">
      <template v-slot:popup-title
        >Не удалось купить лот №: {{ item.contractNumber }} <br />
        {{ item.car.name }}
      </template>
      <template v-slot:popup-content>
        <div class="buyNowError big">
          {{ byNowError }}
        </div>

        <button class="button button--dark col-12" @click="updateList">
          {{ page === "item" ? "Обновить информацию" : "Обновить список" }}
        </button>
      </template>
    </modal-window>
  </div>
</template>

<script setup lang="ts">
import ModalWindow from "~/components/page/modalWindow.vue";
import Preloader from "~/components/page/Preloader.vue";

const props = defineProps<{
  item: any;
  page?: "item" | "list";
}>();

const emit = defineEmits(["updateList"]);

const updateList = () => {
  showBuyNowModal.value = false;
  showErrorModal.value = false;
  emit("updateList");
};

const isLoading = ref(false);
const isBuying = ref(false);
const byNowError = ref("");
const showBuyNowModal = ref(false);
const showErrorModal = ref(false);
const openBuyNowModal = async () => {
  isLoading.value = true;

  let apiRequest = new ApiRequest(
    "get",
    `lots/purchase-status/${props.item.id}`,
    null,
  );

  apiRequest.onError((e) => {
    if (e.errors.lot?.[0]) {
      byNowError.value = e.errors.lot[0];
    } else {
      byNowError.value = "Не удалось купить лот";
    }

    showErrorModal.value = true;
  });

  const result: any = await apiRequest.request();

  isLoading.value = false;

  if (result) {
    if (result?.isPurchased) {
      byNowError.value = "Лот уже куплен другим пользователем";
      showErrorModal.value = true;
    } else {
      showBuyNowModal.value = true;
      byNowError.value = "";
    }
  }
};

const buyNowHandler = async () => {
  isBuying.value = true;
  let apiRequest = new ApiRequest(
    "post",
    "lots/bids/" + props.item.id + "/buy-now",
    null,
  );

  apiRequest.onError((e) => {
    if (e.errors.lot?.[0]) {
      byNowError.value = e.errors.lot[0];
    } else {
      byNowError.value = "Не удалось купить лот";
    }
  });

  const result = await apiRequest.request();

  isBuying.value = false;

  if (result) {
    updateList();
  }
};

const formatNumber = (num: number | undefined) => {
  if (!num) return 0;
  return num.toLocaleString("ru");
};
</script>

<style scoped>
/* Кнопка «Купить» у лотов «Купить сейчас» */
.button.button--buy {
  background: #14beaa;
  border-color: #14beaa;
}

.button.button--buy:hover {
  background: #17d1bb;
  border-color: #17d1bb;
}

.price {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
  border-radius: 5px;
}

.for-button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);

  width: 100px;
}

.buyNowError {
  text-align: center;
  margin-top: 0.2rem;
  font-weight: 600;
  font-size: 12px;
  color: #ff6565;

  &.big {
    font-size: 18px;
    margin-bottom: 2rem;
  }
}

.buy-now-text {
  font-size: 14px;
}
</style>
